import { IsAdmin } from "../Helpers/Utilities";
import WebServiceWrapper from "./WebServiceWrapper";

export const DemographicService = {
    GetUSStates, 
    GetDemographicData, 
    SaveDemographicData,
};

function GetUSStates() {
  return WebServiceWrapper.Get(`/demographic/GetUSStates`);
}

function GetDemographicData(patientId) {
    return WebServiceWrapper.Get(`/demographic/GetDemographicData?patientId=${patientId}&isAdmin=${IsAdmin()}`);
}

function SaveDemographicData(payload) {
  return WebServiceWrapper.Post("/demographic/SaveDemographicData", payload);
}